import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Automatisk fakturering',
  buttons: {
    add_subscription: 'Tilføj abonnement',
    suspend_company: 'Suspendér restaurant',
    restore_company: 'Genopret restaurant',
    edit_suspend: 'Rediger suspenderingsinfo',
    confirm: 'Bekræft',
    cancel: 'Annullér',
  },
  modals: {
    suspend_company: {
      title: 'Er du sikker på, at du vil suspendere {{company}}?',
      description:
        'Dette annullerer alle aktive abonnementer, deaktiverer live-ordrer og underretter restaurantens ejer via e-mail om annulleringen. Vælg en årsag, før du bekræfter.',
      suspense_reason: {
        label: 'Vælg årsag til suspendering',
        placeholder: 'Vælg en årsag',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Lukket eller ejerskifte',
          [SUSPENSE_REASON.LowRoi]: 'Lav ROI',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Følsomhed over for pris/gebyrer',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Manglende integrationer/produktmangler',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Dårlig onboarding/aktivering',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Utilfredshed med support',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Skiftet til konkurrent/markedsplads/DIY',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Skuffende marketingresultater',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Forkert registrering / data',
        },
        validation: {
          required: 'Vælg en årsag',
        },
      },
      suspense_competitor: {
        label: 'Hvilken konkurrent skiftede de til?',
        placeholder: 'Vælg en konkurrent',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Andet',
        },
        validation: {
          required: 'Vælg en konkurrent',
        },
      },
      suspense_reason_notes: {
        label: 'Yderligere kontekst (valgfrit)',
        placeholder: 'Angiv eventuelle yderligere oplysninger',
      },
    },
    restore_company: {
      title: 'Er du sikker på, at du vil genoprette {{company}}?',
      description: 'Du skal stadig oprette abonnement og aktivere live-ordrer manuelt.',
    },
  },
  toasts: {
    failed_to_load_data: 'Abonnementsoplysninger kunne ikke indlæses',
    failed_to_suspend_company: 'Restauranten kunne ikke suspenderes. Kontakt teknisk support',
    failed_to_restore_company: 'Restauranten kunne ikke genoprettes. Kontakt teknisk support',
  },
};
